<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="" name='status'>
      <a-month-picker format="YYYY-MM" valueFormat='YYYY-MM' @change="onMonthChange" />
    </a-form-item>
   <a-form-item label="" name='source_type'>
      <a-select v-model:value="search.source_type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部渠道</a-select-option>
        <a-select-option value="1">会员生日礼包</a-select-option>
        <a-select-option value="2">品牌派券活动</a-select-option>
        <a-select-option value="3">直接发放</a-select-option>
        <a-select-option value="4">扫码活动</a-select-option>
        <a-select-option value="5">云店派券活动</a-select-option>
        <a-select-option value="6">首页优惠礼包</a-select-option>
        <a-select-option value="7">夺宝失败</a-select-option>
        <!-- <a-select-option value="8">礼包活动</a-select-option> -->
      </a-select>
    </a-form-item>
    <a-form-item label="" name='type'>
      <a-select v-model:value="search.coupon_type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部类型</a-select-option>
        <a-select-option :value="2">现金券</a-select-option>
        <a-select-option :value="3">代金券</a-select-option>
        <a-select-option :value="1">折扣券</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="关键词" name='keyword'>
      <a-input-group compact :style="{width:'340px'}">
        <a-select v-model:value="search.search_type" style="width: 35%">
          <a-select-option value="coupon_name">券名称</a-select-option>
          <a-select-option value="coupon_id">卡券ID</a-select-option>
          <a-select-option value="openid">领取人ID</a-select-option>
          <a-select-option value="order_no">购物券订单号</a-select-option>
          <a-select-option value="coupon_sn">券码</a-select-option>
        </a-select>
        <a-input style="width: 65%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-input-group>
    </a-form-item>
    <a-form-item label="门店" name='store_id'>
      <a-input placeholder="选择门店" style="width: 200px;" readonly v-model:value="search.store_name"></a-input>
      <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 3px;" v-if='search.store_name'  @click='search.store_name="";search.store_id="";' />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click="showStore=true">选择</a-button>
    </a-form-item>
    <a-form-item label="领取时间" name='time' class="m-t-10"> 
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    
    <a-form-item class="m-t-10">
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <a-form-item class="m-t-10">
      <a-button type="primary" ghost v-has:grantExport="exportTable">导出</a-button>
    </a-form-item>
    <a-form-item class="m-t-10">
      <a-button type="primary" ghost v-has:grantReport="checkCreateReport">查看生成报表</a-button>
    </a-form-item>
  </a-form>
  <!-- <div class="s_c333 fz-16 s_font_b m-b-20">发放总面值： <span style="color: #D32500;">{{price_total}}</span>元</div> -->
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:openid="{ record }">
      <a-popover title="">
        <template #content>
          <div class="s_p24 s_flex_bian_c">
            <img class="s_bor100 width-100 height-100" :src="record.headimgurl ? record.headimgurl : require('@/assets/images/normal.png')" alt="" style="display:block;object-fit:cover;margin-right:20px">
            <div class="width80  ">
              <p class=" s_c333 ">微信昵称：{{record.nickname || '-'}}</p>
              <p class=" s_c333 ">客户Id：{{record.member_id || '-'}}</p>
              <p class=" s_c333 ">openId：{{record.openid || '-'}}</p>
              <p class=" s_c333 ">姓名  ：{{record.real_name || '-'}}</p>
              <p class=" s_c333  ">所在地区：{{record.address || '-'}}</p>
              <p class=" s_c333 " >关注时间：{{record.subscribe_time || '-'}}</p>
              <router-link :to="'/members/memberList/userDetail?member_id='+record.member_id" tag="a">会员详情</router-link>
            </div>
          </div>
        </template>
        <p class="s_flex_ali"> 
          <img class="width-50 height-50" :src="record.headimgurl ? record.headimgurl : require('@/assets/images/normal.png')" alt="" style="display:block;object-fit:cover;margin-right:10px">{{record.nickname || '-'}}</p>
      </a-popover>
    </template>
    <template v-slot:valid_time="{ record }">
      <p>{{record.coupon.valid_time}}</p>
    </template>

    <template v-slot:action="{ record }">
        <a-button v-has:couponStatisticsDetails="()=>checkDetail(record)" class="m-r-10">详情</a-button>
       <a-button  v-has:grantWriteOff="()=>writeOff(record)"  class="m-r-10" type="primary">核销</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" title="核销确认" centered v-model:visible="visible" destroyOnClose @ok="writeOffComfirm">
    <p class="s_c333 m-b-20 fz-16 s_font_b">确定要对编码为“{{writeData.conpon_sn}}”的{{writeData.coupon_type_text}}做核销操作吗？</p>
    <p class="s_cd41">(一经核销，{{writeData.coupon_type_text}}即为已使用状态，不能再次使用)</p>
  </a-modal>
  <a-modal  :keyboard="false" title="查看详情" centered v-model:visible="detailVisible" :footer="null">
    <p class="s_c333 s_lin_h35">领取人OpenID： {{detail.openid}}</p>
    <p class="s_c333 s_lin_h35">购物券名称： {{detail.name}}</p>
    <p class="s_c333 s_lin_h35">券类型： {{detail.coupon_type_text}}</p>
    <p class="s_c333 s_lin_h35">券码： {{detail.conpon_sn}}</p>
    <p class="s_c333 s_lin_h35">面值： {{detail.amount_text}}</p>
    <p class="s_c333 s_lin_h35">使用条件： {{detail.use_condition}}</p>
    <p class="s_c333 s_lin_h35">有效期： {{detail.valid_period_time}}</p>
    <p class="s_c333 s_lin_h35">发放时间： {{detail.create_time}}</p>
    <p class="s_c333 s_lin_h35">发放类型： {{detail.source_type_text}}</p>
    <p class="s_c333 s_lin_h35">状态： {{detail.coupon_member_status_text}}</p>
  </a-modal>
  <a-modal  :keyboard="false" title="查看详情" centered v-model:visible="reportVisible" destroyOnClose :width="1000" >
    <exportList :type='search.type' />
  </a-modal>
  <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' destroyOnClose :footer="null">
    <selectStore v-on:select="storeSelect" :selectList='[{id:search.store_id}]'></selectStore>
  </a-modal>
</template>
<script>
import { DownOutlined ,CloseCircleFilled} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getCouponLog, couponwriteOff, couponDetailReport } from "@/api/assets";
import { userExportTable } from "@/hooks/userCouponExport.js";
import { iscode } from "@/utils/app";
import exportList from "./exportList";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  type: "1",
  page: 1,
  limit: 10,
  year: "",
  month: "",
  source_type: "",
  coupon_type: "",
  use_type: "",
  search_type: "coupon_name",
  start_time: "",
  end_time: "",
};
export default {
  name: "grantList",
  components: {  exportList,CloseCircleFilled },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      visible: false,
      detailVisible: false,
      time: [],
      price_total: 0,
      total: 1,
      showStore:false
    });
    let columns = [
      {
        title: "领取人信息",
        dataIndex: "openid",
        key: "openid",
        slots: { customRender: "openid" },
      },
       {
        title: "券名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "卡券ID",
        dataIndex: "coupon_id",
        key: "coupon_id",
      },
      {
        title: "券码",
        dataIndex: "conpon_sn",
        key: "conpon_sn",
      },
      {
        title: "优惠",
        dataIndex: "amount_text",
        key: "amount_text",
      },
      {
        title: "券类型",
        dataIndex: "coupon_type_text",
        key: "coupon_type_text",
      },
      {
        title: "发放渠道",
        dataIndex: "source_type_text",
        key: "source_type_text",
      },
      {
        title: "发放时间",
        dataIndex: "create_time",
        key: "create_time",
      },

      {
        title: "有效期",
        dataIndex: "valid_period_time",
        key: "valid_period_time",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getCouponLog(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });

    const onMonthChange = (e) => {
      if(!e){
         search.value.year = '';
      search.value.month = '';
        return
      }
      const d = e.split('-')
      search.value.year = d[0];
      search.value.month = d[1];
    };
    const detail = ref({});
    const checkDetail = (d) => {
      detail.value = d;
      state.detailVisible = true;
    };
    // 核销弹窗
    const writeData = ref({});
    const writeOff = (data) => {
      state.visible = true;
      writeData.value = data;
    };
    const writeOffComfirm = async () => {
      let result = await couponwriteOff({ log_id: writeData.value.id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        state.visible = false;
        initData(search.value);
      }
    };
    // 查看生成报表
    const reportVisible = ref(false);
    const checkCreateReport =  () => {
        reportVisible.value = true;
    };
    // 导出
    const { exportHandle } = userExportTable();
    const exportTable = () => {
      exportHandle({
        ...search.value,
        export_type: search.value.type,
        limit: 5000,
      });
    };
    //选择门店
    const storeSelect = (data) => {
      search.value.store_name = data.store_name
      search.value.store_id = data.id
      state.showStore = false
    }
    return {
      ...toRefs(state),
      search,
      data,
      reportVisible,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      exportTable,
      onMonthChange,
      checkDetail,
      detail,
      writeData,
      writeOff,
      writeOffComfirm,
      checkCreateReport,
      storeSelect
    };
  },
};
</script>